// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3OsL1","info_field":"info_field-35O1b","info_field__cities":"info_field__cities-2A8YD","info_field__travellers":"info_field__travellers-eNaam"};